import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const ImportTypeSchema = z.object({
	id: z.number().optional(),
	name: z.string(),
});

export type ImportType = z.infer<typeof ImportTypeSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	params: object,
): Promise<{ data: ImportType[]; total: number }> => {
	try {
		let queryString = '';
		if (params) {
			const paramsAsString = JSON.stringify(params)
				.replace(/:/g, '=')
				.replace(/,/g, '&')
				.replace(/[{}"]/g, '');

			const searchParams = new URLSearchParams(paramsAsString);
			if (pagination) {
				searchParams.append('pageSize', pagination.pageSize.toString());
				searchParams.append('pageIndex', pagination.pageIndex.toString());
			}

			if (sorting.length > 0) {
				searchParams.append('sortBy', sorting[0].id);
				searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
			}

			queryString = `?${searchParams.toString()}`;
		}

		const response = await fetch(`/admin/import-type${queryString}`);

		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};

export const ImportTypeTabsSchema = z.object({
	importTypeId: z.number(),
	importTypeName: z.string(),
	tabs: z.array(z.string()),
});

export type ImportTypeTabs = z.infer<typeof ImportTypeTabsSchema>;

export const getTabs = async (importTypeId: number): Promise<ImportTypeTabs> => {
	const response = await fetch(`/admin/import-type/tabs/${importTypeId}`);
	return await response.json();
};
